import { CMI_DIGEST_WATCHLIST_TYPE, CmiDigestWatchlistType } from 'types/cmiDigestWatchlist';

export const isValidTypeFilter = (value: string | null): value is CmiDigestWatchlistType =>
  Boolean(value) && (Object.values(CMI_DIGEST_WATCHLIST_TYPE) as string[]).includes(value as string);

export const stripWeekdayFromPeriodLabel = (periodLabel: string) =>
  periodLabel.replace(/[A-Za-z]{3}, (?=[A-Za-z]{3} \d)/g, '');
